// extracted by mini-css-extract-plugin
module.exports = {"page":"_2FKLsu_iz03zc2ztV4tqsR","productNavigation":"zOF8nxCrMGS7AOhrKfY6C","header":"_1DnyKvXqQY0XrVIR7hn6oy"};